class AthleteVideoFacade extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('.athlete-video__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => this.load(), { once: true });
  }

  load() {
    const platform = this.dataset.platform;
    const id = this.dataset.videoId;
    const title = this.dataset.title || '';
    if (!platform || !id) return;

    const iframe = document.createElement('iframe');
    iframe.setAttribute('title', title);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'eager');

    if (platform === 'youtube') {
      iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
      );
    } else if (platform === 'vimeo') {
      iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    } else {
      return;
    }

    this.innerHTML = '';
    this.appendChild(iframe);
  }
}

if (!customElements.get('athlete-video-facade')) {
  customElements.define('athlete-video-facade', AthleteVideoFacade);
}

(() => {
  const targets = document.querySelectorAll('[data-athlete-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    targets.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  targets.forEach((el) => observer.observe(el));
})();
